export function reportingSnapshotCompletenessAlert() {
    return null;
}
